"use strict";

(function (global) {

  var tabSelector = "div.explorer-search-panel__item";
  var actionButtonSelector = '.action-button';

  /**
  * Класс-обертка для закладки в проводнике.
  * @class WebAccess.components.wrappers.sideBar.Tabs
  * @extends WebAccess.Collecton
  * @since 5.2.0.1600  
  */
  var _ExplorerTab = WebAccess.components.wrappers.BasePageElement.extend({
    dfmName: '',

    // Конструктор.
    init: function (itemSelector, opt_current) {
      var me = this;
      me._jObject = $(itemSelector)
      me._super(me._jObject);

      me.selector = format(me._byNameSelectorTemplate, tabSelector, me.name);
      me.dfmName = me._jObject.data('name');

      me._jActionButon = me._jObject.find(actionButtonSelector);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Имитировать щелчок мыши.
     * Имитация щелчка мыши на кнопке либо установка обработчика на событие onClick, если передан callback. 
     * Заменяет обработчик, установленный по умолчанию. Используется в прикладной разработке.
     * 
     * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по кнопке
     * @method WebAccess.components.wrappers.BasePageElement#click
     * @throws ERR_OBJECT_IS_ALREADY_RENDERED – объект уже отображен.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     *
     * @example
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click();
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click(function() {
     *  alert("Существующие обработчки событий click были перезаписаны данным");
     * })
     */
    click: function (opt_callback) {
      var instance = this;
      if ($.isFunction(opt_callback)) {
        this._disableClickHandler(this._jActionButon);
        this.unbind('click').bind("click", opt_callback);
      } else {
        this._jActionButon.click();
      }
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  });

  global.components.wrappers.sideBar._ExplorerTab = _ExplorerTab;

})(window.WebAccess);